(function($) {

	'use strict';

    var filters = {}
    var currentPage = 1
    var scrolled = false

	var init = function() {
		// $('.archive-job__header__select').on('change', function(){
		// 	$('.archive-job__header__form').submit();
		// });
		// $('.archive-job__header__form').submit(function(e){
		// 	var has_values = false;
		// 	$(this).find(':input').each(function(i){
		// 		if(!$(this).val()){
		// 			$(this).attr('name', '');
		// 		} else {
		// 			has_values = true;
		// 		}
		// 	});
		// 	if(!has_values){
		// 		e.preventDefault();
		// 		window.location = $(this).attr('action');
		// 	}
		// });


		// $('#jobs_more').click(function() {
		// 	ajaxMoreJobs();
        // });
        
        initFilters();
        initMoreResults();

        $(window).on("popstate", function(e) {
            if (e.originalEvent.state !== null) {
                location.reload()
            }
        })
	}

	var initFilters = function() {

        var $filtersBrand = $('.archive-job__header__select#brand')
        filters.br = $filtersBrand.val()
        $filtersBrand.change( function() {
            filters.br = $(this).val()
            resetResults()
        })

        var $filtersService = $('.archive-job__header__select#service')
        filters.se = $filtersService.val()
        $filtersService.change( function() {
            filters.se = $(this).val()
            resetResults()
        })

    }
    
    var initMoreResults = function() {
        
        $(window).scroll(function() {
            var windowScroll = $(window).scrollTop();

            var footerOffset = $('footer').offset().top;

            var windowHeight = $(window).height();

            if(!scrolled && windowScroll >= footerOffset - windowHeight + 100) {
                appendResults();

                scrolled = true;
            }
        })
        
    }
    
    var resetResults = function() {
        $('.archive-job__item').remove()
        currentPage = 0
        appendResults()
    }

    var appendResults = function() {
        var beforeScrollTop = $(window).scrollTop();
        MyAjax.data = {
            action  	: 'jobs_more_results',
            paged		: ++currentPage,
            br          : filters.br,
            se          : filters.se,
        }
        $.ajax({
            url : MyAjax.ajaxurl,
            data: MyAjax.data,
            type: 'POST',
            beforeSend: function(response) {
                $('.archive-job__loader').show()
            },
            success: function(response) {
                $('.archive-job__loader').hide()
                var json = jQuery.parseJSON(response)
                $('.archive-job__list').append(json.contents)
                updateURL()
                $(window).scrollTop(beforeScrollTop);
            },
            error: function(response) {
            },
            complete: function(response) {
            }
        })
    }

    var updateURL = function() {
        var url = window.location.href.split("?")[0]
        var position = 0
        for (var filter in filters) {

            if (filters[filter] === null || filters[filter].length <= 0)
                continue
            
            if(position > 0) {
                url += '&'
            } else {
                url += '?'
            }

            position++
            url += filter + '=' + filters[filter]
        }
        window.history.pushState({},"", url)
    }

	// var ajaxMoreJobs = function() {
	// 	jQuery.post(
    //         MyAjax.ajaxurl,
    //         {
    //             'action': 'infinite_jobs',
    //             'offset': offset_job,
    //         },
    //         function(response){

    //             if(response != 'false'){

    //                 offset_job += 9;
    //                 $('.archive-job__list').append(response);

    //             }else{
                    
    //                 $('#jobs_more').remove();
                    
    //             }

    //         }
    //     );
	// }

	$(document).ready(function() {
        if($('body').hasClass('post-type-archive')) {
            init();
        }
	});

})(jQuery);